import InteriorDesignIcon from "../../../assets/interior-design.svg";
import type { ProductGroup } from "../../../types";

export const interiorDesign: ProductGroup = {
  id: "interiorDesign",
  title: "interiorDesign.title",
  icon: {
    src: InteriorDesignIcon,
    width: 75,
    height: 40,
  },
};
